import React from 'react';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { Button } from '@material-ui/core';
import { Breadcrumb } from 'components';
import { useStyles } from './styles';
import GiftCodesTable from './giftCodes/GiftCodesTable';


const GiftCodes = () => {
  const history = useHistory();
  const classes = useStyles();
  const {profile} = useSelector((state: IReduxState) => state.user);
  const permissions = profile?.config?.permissions || {};

  return (
    <div className="flex-grow flex-column relative h-full scroll-y pb-5">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Gift Cards'}
          ]}
        />
      </div>
      {permissions?.giftCardsCreate &&
        <div className={'px-6 flex justify-end w-full'}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => history.push({pathname: '/gift-cards/create-gift-code'})}
          >
            Create New Gift Code
          </Button>
        </div>}
      <div className={`${classes.card} mt-4`}>
        <GiftCodesTable />
      </div>
    </div>
  );
};

export default GiftCodes;
